export enum IconSize {
    Small = "SMALL",
    Medium = "MEDIUM",
    Large = "LARGE"
}